module.exports = __webpack_public_path__ + "static/media/27.89dfaba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/27.jpg
// module id = 560
// module chunks = 0